import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import AdminLogin from './components/AdminLogin';
import DashboardLayout from './components/admin/DashboardLayout';
import SectionsPage from './components/admin/SectionsPage';
import NewsPage from './components/admin/NewsPage';
import SlideshowPage from './components/admin/SlideshowPage';
import GalleryPage from './components/admin/GalleryPage';
import PostersPage from './components/admin/PostersPage';
import PosterImagesPage from './components/admin/PosterImagesPage';
import VereinePage from './components/admin/VereinePage';
import StimmArtPage from './components/admin/StimmArtPage';
import WiesenInfoPage from './components/admin/WiesenInfoPage';
import BieberInfoPage from './components/admin/BieberInfoPage';
import YoungStarsPage from './components/admin/YoungStarsPage';
import ContactFormPage from './components/admin/ContactFormPage';
import FontsPage from './components/admin/FontsPage';
import AboutPage from './components/admin/AboutPage';
import ContactPage from './components/admin/ContactPage';
import SettingsPage from './components/admin/SettingsPage';
import ImprintPage from './components/admin/ImprintPage';
import PrivacyPage from './components/admin/PrivacyPage';
import Imprint from './components/Imprint';
import Privacy from './components/Privacy';
import PosterGallery from './components/PosterGallery';
import WiesenInfo from './components/WiesenInfo';
import WiesenImprint from './components/WiesenImprint';
import WiesenPrivacy from './components/WiesenPrivacy';
import BieberInfo from './components/BieberInfo';
import BieberImprint from './components/BieberImprint';
import BieberPrivacy from './components/BieberPrivacy';
import './index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/impressum',
    element: <Imprint />,
  },
  {
    path: '/datenschutz',
    element: <Privacy />,
  },
  {
    path: '/galerie/:slug',
    element: <PosterGallery />,
  },
  {
    path: '/wiesen-info',
    element: <WiesenInfo />,
  },
  {
    path: '/wiesen-info/impressum',
    element: <WiesenImprint />,
  },
  {
    path: '/wiesen-info/datenschutz',
    element: <WiesenPrivacy />,
  },
  {
    path: '/bieber-info',
    element: <BieberInfo />,
  },
  {
    path: '/bieber-info/impressum',
    element: <BieberImprint />,
  },
  {
    path: '/bieber-info/datenschutz',
    element: <BieberPrivacy />,
  },
  {
    path: '/admin',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: <DashboardLayout />,
    children: [
      {
        path: 'sections',
        element: <SectionsPage />,
      },
      {
        path: 'news',
        element: <NewsPage />,
      },
      {
        path: 'slideshow',
        element: <SlideshowPage />,
      },
      {
        path: 'gallery',
        element: <GalleryPage />,
      },
      {
        path: 'posters',
        element: <PostersPage />,
      },
      {
        path: 'posters/:posterId/images',
        element: <PosterImagesPage />,
      },
      {
        path: 'vereine',
        element: <VereinePage />,
      },
      {
        path: 'stimmart',
        element: <StimmArtPage />,
      },
      {
        path: 'youngstars',
        element: <YoungStarsPage />,
      },
      {
        path: 'wiesen-info',
        element: <WiesenInfoPage />,
      },
      {
        path: 'bieber-info',
        element: <BieberInfoPage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
      {
        path: 'contact-form',
        element: <ContactFormPage />,
      },
      {
        path: 'fonts',
        element: <FontsPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'imprint',
        element: <ImprintPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPage />,
      },
    ],
  },
]);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find root element');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <ThemeProvider>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </ThemeProvider>
  </StrictMode>
);